import React, { ComponentProps } from 'react'
import { useFormContext, get, RegisterOptions } from 'react-hook-form'
import { TextField } from  "@moneyforward/mfx_biz_react_components";

type Props = ComponentProps<typeof TextField> & {
  name: string
  registerOptions?: RegisterOptions
}

const InnerFormTextField = (
  props: Props,
  ref: React.ForwardedRef<HTMLInputElement>,
) => {
  const { register, formState } = useFormContext()
  const { errors } = formState
  const { registerOptions, ...inputProps } = props
  const methods = register(props.name, registerOptions)

  return (
    <TextField
      {...inputProps}
      isError={get(errors, props.name)}
      name={methods.name}
      ref={(el) => {
        methods.ref(el)
        if (typeof ref === 'function') {
          ref(el)
          return
        }
        if (ref) {
          ref.current = el
        }
      }}
      onChange={(e) => {
        methods.onChange(e)
        props.onChange && props.onChange(e)
      }}
      onBlur={(e) => {
        methods.onBlur(e)
        props.onBlur && props.onBlur(e)
      }}
    />
  )
}

export const FormTextField = React.forwardRef(InnerFormTextField)
